import { useEffect, useRef, useState } from "react"
import { useSelector } from "react-redux"
import moment from "moment"
import * as incomeStatementApis from "../../utilities/apis/income_statement"
import Layout from "../../components/Layout"
import IncomeStatementTable from "../../components/IncomeStatementTable"
import IncomeStatementGraph from "../../components/IncomeStatementGraph"

const ReportIncomeStatement = () => {
  const { token } = useSelector(state => state.user)
  const fromRef = useRef(null)
  const toRef = useRef(null)
  const [type, setType] = useState("table")
  const [profitIn, setProfitIn] = useState("value")

  const handleSubmit = async () => {
    try {
      const from = moment(fromRef.current.value).format()
      const to = moment(`${toRef.current.value} 23:59`).format()
      const payload = { from, to }

      const response = await incomeStatementApis.createIncomeStatement(token, payload)
      if (!response.status) throw new Error(response.message)

      alert("Income statement saved")
    } catch (error) {
      alert(error.message)
    }
  }

  const handleDelete = async () => {
    try {
      if (!window.confirm("Are you sure you want to delete all income statements? You will lost all your data.")) return

      const response = await incomeStatementApis.deleteIncomeStatements(token)
      if (!response.status) throw new Error(response.message)

      alert("Income statements deleted")
    } catch (error) {
      alert(error.message)
    }
  }

  useEffect(() => {
    fromRef.current.value = moment().format('YYYY-MM-01')
    toRef.current.value = moment().format('YYYY-MM-DD')
  }, [])

  return (
    <Layout
      header={true}
      footer={true}
    >
      <main className="py-3">
        <div className="container-fluid">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <p className="lead text-body-emphasis fw-bold m-0">Income Statement</p>
            <div className="d-flex gap-2">
              <div className="btn-group btn-group-sm" role="group">
                <button type="button" className={"btn btn-light rounded-start-4 " + (profitIn === "value" ? "active" : "")} onClick={() => setProfitIn("value")}>Value</button>
                <button type="button" className={"btn btn-light rounded-end-4 " + (profitIn === "percent" ? "active" : "")} onClick={() => setProfitIn("percent")}>Percent</button>
              </div>
              <div className="btn-group btn-group-sm" role="group">
                <button type="button" className={"btn btn-light rounded-start-4 " + (type === "table" ? "active" : "")} onClick={() => setType("table")}>Table</button>
                <button type="button" className={"btn btn-light rounded-end-4 " + (type === "graph" ? "active" : "")} onClick={() => setType("graph")}>Graph</button>
              </div>
              <button type="button" className="btn btn-light-danger rounded-4" onClick={handleDelete}>Delete All</button>
            </div>
          </div>

          <div className="border rounded-4 mb-3">
            <div className="p-3 border-bottom rounded-top-4 bg-secondary">
              <div className="row">
                <div className="col-md-2">
                  <input ref={fromRef} type="date" className="form-control form-control-sm rounded-3" id="from" />
                </div>
                <div className="col-md-2">
                  <input ref={toRef} type="date" className="form-control form-control-sm rounded-3" id="to" />
                </div>
                <div className="col-md-5" />
                <div className="col-md-3">
                  <div className="d-flex justify-content-end gap-2">
                    <button type="button" className="btn btn-sm btn-light-theme rounded-3" onClick={handleSubmit}><i className="fas fa-file-invoice me-2"></i> Generate Statement</button>
                  </div>
                </div>
              </div>
            </div>
            {type === "table" && <IncomeStatementTable profitIn={profitIn} />}
            {type === "graph" && <div className="p-3"><IncomeStatementGraph profitIn={profitIn} /></div>}
          </div>
        </div>
      </main>
    </Layout>
  )
}

export default ReportIncomeStatement
